import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/config/router.js'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    team: [],
    match: [],
    token: undefined,
    firstWinner:{},
    user: {},
    apiCalls: {},
    currentServerTime:null       
  },
  mutations: {
    getTeams(state, team) {
      state.team = team;
    },
    getGambles(state, team) {
      state.team = team;
    },
    getFirstFourWinners(state, fourWinner) {
      state.fourWinner = fourWinner;
    },
    getFirstWinner(state, firstWinner) {
      state.firstWinner = firstWinner;
    },
    getMatches(state, match) {
      state.match = match;
    },
    SET_USER_DATA(state, userData) {
      state.user = userData
    },       
  },  
  getters: {
    getUsersId: state => {
      // return state.user.map(user => user.id)      
      return state
    }
  },
  actions: {
    setUserData({commit}, userData) {      
      commit("SET_USER_DATA", userData);      
      router.push({name: 'Main'})
    },  
    getTeams({commit}) {
      return new Promise((resolve) => {
        axios.get(process.env.VUE_APP_API_URL + 'team').then(response => {
          commit("getTeams", response.data.team)
          resolve()
        })
          .catch(() => console.log('error getting endpoints'));
      })
    },
    // getMatches({commit}) {
    //   const _this = this;
    //   return new Promise((resolve) => {
    //     axios.get(process.env.VUE_APP_API_URL + 'match', {
    //       params: {
    //         relations: 1,
    //         "relations_params[gamble][where][0][0]": 'where',
    //         "relations_params[gamble][where][0][1]": 'user_id',
    //         "relations_params[gamble][where][0][2]": _this.state.user.id,
    //         "order_by[0][0]": 'time',
    //         "order_by[0][1]": 'asc'
    //       }
    //     }).then(response => {
    //       commit("getMatches", response.data.match)
    //       resolve()
    //     })
    //       .catch(() => console.log('error getting endpoints'));
    //   })
    // },
  }
})
